import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { FiMapPin, FiClock, FiMail, FiPhone, FiSend, FiPhoneCall } from 'react-icons/fi';
import './ContactUs.css';

export default function ContactUs() {
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    emailjs
      .send('service_hfjuhy8', 'template_cv0fu57', templateParams, 'AKDzfoXfa9922wbXV')
      .then(
        (result) => {
          console.log(result.text);
          setStatus('Message sent successfully!');
          setFormData({
            email: '',
            subject: '',
            message: '',
          });
        },
        (error) => {
          console.log(error.text);
          setStatus('Failed to send message. Please try again.');
        }
      );
  };

  return (
    <div className="contact-page-container">
      {/* Contact Hero Header */}
      <section className="contact-hero-section">
        <div className="contact-hero-content">
          <span className="contact-eyebrow">
            <FiPhoneCall className="eyebrow-icon" /> GET IN TOUCH
          </span>
          <h1>Contact Us</h1>
          <p>
            We're here to help. Reach out to our team for inquiries, support, or partnership opportunities.
          </p>
        </div>
      </section>

      <div className="contact-main-content">
        {/* Contact Info Cards */}
        <section className="contact-cards-section">
          <div className="contact-cards-grid">
            <div className="contact-info-card">
              <div className="card-icon-wrapper">
                <FiMapPin />
              </div>
              <h3>Our Address</h3>
              <p>B 301 New Gokul Heights CHSL, Near Tera Panth Bhawan, Thakur complex, Kandivali(east), Mumbai</p>
            </div>

            <div className="contact-info-card">
              <div className="card-icon-wrapper">
                <FiClock />
              </div>
              <h3>Office Timing</h3>
              <p>Mon To Sat - 10.00AM- 07.00PM</p>
            </div>

            <div className="contact-info-card">
              <div className="card-icon-wrapper">
                <FiMail />
              </div>
              <h3>Our Email</h3>
              <a href="mailto:info@databoltahai.in" className="contact-link">
                info@databoltahai.in
              </a>
            </div>

            <div className="contact-info-card">
              <div className="card-icon-wrapper">
                <FiPhone />
              </div>
              <h3>Our Phone</h3>
              <a href="tel:+9170215-20017" className="contact-link">
                +91 70215-20017
              </a>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="contact-form-section">
          <div className="contact-form-card">
            <h3>Send Us a Message</h3>
            <p className="form-subtitle">Fill out the form below and our team will get back to you shortly.</p>

            {status && (
              <p
                className={`status-message ${
                  status.includes('successfully') ? 'success' : 'error'
                }`}
              >
                {status}
              </p>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="How can we help you?"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message <FiSend style={{ marginLeft: '8px' }} />
              </button>
            </form>
          </div>
        </section>

        {/* Embedded Google Map */}
        <section className="map-section">
          <div className="map-header">
            <h3>Find Us on Google Maps</h3>
          </div>
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.611878030617!2d72.86276546980388!3d19.2121472079737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7309348dd09%3A0x4c489bd3db40ad5c!2sDimple%20Arcade%2C%20Asha%20Nagar%20Rd%2C%20Kandivali%2C%20Gayatri%20Nagar%2C%20Asha%20Nagar%2C%20Kandivali%20East%2C%20Mumbai%2C%20Maharashtra%20400101!5e0!3m2!1sen!2sin!4v1738905446397!5m2!1sen!2sin"
              width="100%"
              height="420"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Data Bolta Hai Office Location"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
}
